import apiClient from '../http/apiClient';

export default class PatientTypeApiService {
    static list = () => apiClient.get('/patient-type');
}
